module.exports = __webpack_public_path__ + "img/Doc11a_20160159-001_p3.045bf960.jpg";